import { useGetEmployeePhotoQuery } from '../redux/api/employee.api';

/**
 * Returns the employee profile photo data URL for a given Azure AD object ID.
 * Returns null when the ID is missing, no photo exists (404), or request fails.
 */
export function useEmployeePhotoById(oid?: string): string | null {
  const normalizedOid = oid?.trim();

  const { data: photoUrl } = useGetEmployeePhotoQuery(
    { oid: normalizedOid ?? '' },
    { skip: !normalizedOid }
  );

  return photoUrl ?? null;
}
